import { Edit, MoreVertical, Trash2 } from "lucide-react";
import React from "react";

const LeaveManagementList = ({ loading, leavemanagements, onHandleRemove }) => {
  const calculateDuration = (from, to) => {
    const start = new Date(from);
    const end = new Date(to);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return `${diffDays} Day${diffDays > 1 ? "s" : ""}`;
  };

  const getStatusBadge = (status) => {
    const base = "px-2 py-1 rounded text-white text-sm";
    if (status === "approved") return `${base} bg-green-500`;
    if (status === "pending") return `${base} bg-orange-500`;
    if (status === "rejected") return `${base} bg-red-500`;
    return `${base} bg-green-500`;
    // return base;
  };

  const getStatusClass = (status) => {
    status = status?.toLowerCase();
    if (status.includes("pending"))
      return "badge bg-warning text-dark rounded-pill px-3 py-2 text-capitalize";
    if (status.includes("approved"))
      return "badge bg-success rounded-pill px-3 py-2 text-capitalize";
    if (status.includes("reject"))
      return "badge bg-danger rounded-pill px-3 py-2 text-capitalize";
    return "badge bg-secondary rounded-pill px-3 py-2 text-capitalize";
  };

  return (
    // <div className="emp-list-container mt-4">
    //   <div className="d-flex flex-column gap-1">
    //     <h5 className="fs-4 fw-semibold m-0">Leave Requests</h5>
    //     <input
    //       type="text"
    //       placeholder="Search leavemanagements..."
    //       className="form-control mt-2 mb-3"
    //       style={{ backgroundColor: "#f9f9fa" }}
    //     />
    //   </div>

    //   <div className="table-responsive mt-2">
    //     <table className="table mb-0 table-hover mt-2">
    //       <thead>
    //         <tr className="text-muted small border-top align-middle">
    //           <th className="text-muted fw-medium">Employee Id</th>
    //           <th className="text-muted fw-medium">Employee Name</th>
    //           <th className="text-muted fw-medium">Department</th>
    //           <th className="text-muted fw-medium">Leave Type</th>
    //           <th className="text-muted fw-medium">From Date</th>
    //           <th className="text-muted fw-medium">To Date</th>
    //           <th className="text-muted fw-medium">Duration</th>
    //           <th className="text-muted fw-medium">Status</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         {loading ? (
    //           <tr>
    //             <td colSpan="5" className="text-center text-muted py-3">
    //               Loading..
    //             </td>
    //           </tr>
    //         ) : leavemanagements.length > 0 ? (
    //           leavemanagements.map((l) => (
    //             <tr key={l.id} className="align-middle">
    //               <td>{l.employee.employee_code}</td>
    //               <td>
    //                 {l.employee.first_name} {l.employee.last_name}
    //               </td>
    //               <td>{l.employee.department || "-"}</td>
    //               <td>{l.type.short_name}</td>
    //               <td>{l.from_date}</td>
    //               <td>{l.to_date}</td>
    //               <td>{calculateDuration(l.from_date, l.to_date)}</td>
    //               <td>
    //                 <span
    //                   className={`badge ${
    //                     l.status === "approved"
    //                       ? "bg-success"
    //                       : l.status === "pending"
    //                       ? "bg-warning text-dark"
    //                       : l.status === "rejected"
    //                       ? "bg-danger"
    //                       : "bg-success"
    //                   }`}
    //                 >
    //                   {l.status}
    //                 </span>
    //               </td>
    //               <td>
    //                 <div class="dropdown">
    //                   <MoreVertical
    //                     size={16}
    //                     class="dropdown-toggle"
    //                     data-bs-toggle="dropdown"
    //                     aria-expanded="false"
    //                     style={{ cursor: "pointer" }}
    //                   />
    //                   <ul class="dropdown-menu">
    //                     <li>
    //                       <div class="dropdown-item">
    //                         <div className="d-flex align-items-center gap-1">
    //                           <Edit size={16} />
    //                           <span>Edit</span>
    //                         </div>
    //                       </div>
    //                     </li>
    //                     <li>
    //                       <div class="dropdown-item">
    //                         <div
    //                           className="text-danger d-flex align-items-center gap-1"
    //                           onClick={() => onHandleRemove(l.id)}
    //                         >
    //                           <Trash2 size={16} />
    //                           <span>Remove</span>
    //                         </div>
    //                       </div>
    //                     </li>
    //                   </ul>
    //                 </div>
    //               </td>
    //             </tr>
    //           ))
    //         ) : (
    //           <tr>
    //             <td colSpan={5} className="text-center text-muted py-3">
    //               No Data found.
    //             </td>
    //           </tr>
    //         )}
    //       </tbody>
    //     </table>
    //   </div>
    // </div>
    <div className="container mt-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white border-0 pb-0">
          <h5 className="fw-semibold mb-0">Employee Leave Details</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr className="text-secondary small text-uppercase">
                  <th>Employee Id</th>
                  <th>Employee Name</th>
                  <th>Department</th>
                  <th>Leave Type</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Duration</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center text-muted py-3">
                      Loading..
                    </td>
                  </tr>
                ) : leavemanagements.length > 0 ? (
                  leavemanagements.map((l, i) => (
                    <tr key={i}>
                      <td className="fw-semibold">
                        {l?.employee?.employee_code}
                      </td>
                      <td>{l?.employee?.first_name}</td>
                      <td>{l?.employee?.department}</td>
                      <td>{l?.type?.short_name}</td>
                      <td>{l?.from_date}</td>
                      <td>{l?.to_date}</td>
                      <td>{calculateDuration(l.from_date, l.to_date)}</td>
                      <td>
                        <span className={getStatusClass(l?.status)}>
                          {l?.status.replaceAll("_", " ")}
                        </span>
                      </td>
                      <td className="text-end">
                        <button
                          className="btn btn-link text-muted p-0"
                          title="Actions"
                        >
                          <i className="bi bi-three-dots-vertical fs-5"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center text-muted py-3">
                      No Data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveManagementList;
